import CityPageTemplate from "../city-template/CityPageTemplate";
import { bardstownConfig } from "./data";

export default function BardstownPage() {
  return <CityPageTemplate config={bardstownConfig} />;
}